import { Add, Edit } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Tooltip } from "@mui/material";
import FiveImagesPreview from "./PreviewComponents/FiveImagesPreview";
import FourImagesPreview from "./PreviewComponents/FourImagesPreview";
import OneImagePreview from "./PreviewComponents/OneImagePreview";
import ThreeImagesPreview from "./PreviewComponents/ThreeImagesPreview";
import TwoImagesPreview from "./PreviewComponents/TwoImagesPreview";
import { s3baseUri } from "../../config/config";

export default function PostImagesPreview({
  imagesList,
  maxHeight = "500px",
  isEditOptions = false,
  uploadImagesOnClick = () => {},
  setImagesList = () => {},
  openAllImagesModal = () => {},
  isAllImagesClickAble = false,
}) {
  async function checkImagesWiderThanTall(number = 1, height = maxHeight) {
    return Promise.all(
      imagesList.slice(0, number).map((imageSrc) => {
        return new Promise((resolve) => {
          if (imageSrc.is_wider || imageSrc.is_wider == false) {
            resolve(imageSrc.is_wider);
          }
          const img = new Image();
          img.src =
            imageSrc?.type === "file"
              ? URL.createObjectURL(imageSrc?.path)
              : imageSrc?.path?.startsWith("data:image")
              ? imageSrc?.path
              : s3baseUri + imageSrc.thumbnail_1;

          img.onload = function () {
            resolve(img.width > img.height);
          };

          img.onerror = function () {
            resolve(false); // Assume false if image fails to load
          };
        });
      })
    ).then((results) => results.every((isWider) => isWider)); // Return true only if ALL images are wider
  }

  const imageTag = (image, index, with100 = true, isSingleImage = false) => {
    return (
      <img
        src={
          image?.type === "file"
            ? URL.createObjectURL(image?.path)
            : image?.path?.startsWith("data:image")
            ? image?.path
            : s3baseUri + image.thumbnail_1
        }
        style={{
          maxHeight: "inherit",
          height: "inherit",
          width: with100 ? "100%" : "",
          objectFit: "cover",
          minWidth: with100 ? "" : "70%",
          width: "100%",
          // transform: with100 ? "scale(1)" : "scale(1.5)",
          borderTopLeftRadius: isSingleImage ? "" : "inherit",
          borderTopRightRadius: isSingleImage ? "" : "inherit",
          borderBottomLeftRadius: isSingleImage ? "" : "inherit",
          borderBottomRightRadius: isSingleImage ? "" : "inherit",
          border: !isSingleImage && "1px solid rgba(0, 0, 0, 0.125)",
          cursor: isAllImagesClickAble ? "pointer" : "default",
        }}
        onClick={() => {
          if (isAllImagesClickAble) {
            openAllImagesModal(null, index);
          }
        }}
      />
    );
  };

  return (
    <div className="image-feed-preview">
      {isEditOptions && imagesList.length > 0 && (
        <>
          <div
            style={{
              position: "absolute",
              width: "calc(100% - 16px)",
              zIndex: "100",
            }}
          >
            <div
              className="d-flex justify-content-between align-items-start px-3"
              style={{
                minHeight: "48px",
              }}
            >
              <div className="d-flex align-items-center flex-wrap show-on-hover-element">
                {imagesList.length > 1 && (
                  <button
                    className="mt-2 me-2 btn-outlined-sm !tw-bg-white"
                    onClick={() => openAllImagesModal()}
                  >
                    {"View All"}
                    <Edit />
                  </button>
                )}
                <button
                  className="mt-2 btn-outlined-sm !tw-bg-white"
                  onClick={uploadImagesOnClick}
                >
                  {"Add Images"}
                  <Add />
                </button>
              </div>

              <div className="mt-2">
                <Tooltip placement="top" title={"Remove All Images"}>
                  <IconButton
                    style={{ backgroundColor: "#FFFFFF" }}
                    size="small"
                    color="inherit"
                    onClick={() => setImagesList([])}
                  >
                    <CloseIcon style={{ color: "black", cursor: "pointer" }} />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </div>
        </>
      )}
      {imagesList.length == 1 && (
        <OneImagePreview
          checkImagesWiderThanTall={checkImagesWiderThanTall}
          maxHeight={maxHeight !== "500px" ? "750px" : "500px"} //pass 750 for postcard and 500 for upload image component
          imageTag={imageTag}
          imagesList={imagesList}
        />
      )}
      {imagesList.length == 2 && (
        <TwoImagesPreview
          checkImagesWiderThanTall={checkImagesWiderThanTall}
          maxHeight={maxHeight}
          imageTag={imageTag}
          imagesList={imagesList}
        />
      )}
      {imagesList.length == 3 && (
        <ThreeImagesPreview
          checkImagesWiderThanTall={checkImagesWiderThanTall}
          maxHeight={maxHeight}
          imageTag={imageTag}
          imagesList={imagesList}
        />
      )}
      {imagesList.length == 4 && (
        <FourImagesPreview
          checkImagesWiderThanTall={checkImagesWiderThanTall}
          maxHeight={maxHeight}
          imageTag={imageTag}
          imagesList={imagesList}
        />
      )}
      {imagesList.length >= 5 && (
        <FiveImagesPreview
          checkImagesWiderThanTall={checkImagesWiderThanTall}
          maxHeight={maxHeight}
          imageTag={imageTag}
          imagesList={imagesList}
          handleOpenDetails={() => openAllImagesModal()}
        />
      )}
    </div>
  );
}
